import type { AbilityBuilder } from '@casl/ability'
import type { AppAbility } from '~/types/authorization.type'
import type { User } from '~/types/user.type'
import { userRoles } from '../roles'

export function defineSchedulingAbilities(abilityBuilder: AbilityBuilder<AppAbility>, user: User) {
  const { can } = abilityBuilder

  can('read', 'scheduling')

  const roles = userRoles(user)

  if (roles.administrator || roles.client_lead || roles.people_lead || roles.scheduling) {
    can(['create', 'update', 'delete', 'restore'], 'schedule')
  }
}
